import React from 'react';
import { Timeline } from '@mantine/core';
//import { dateOptions } from '../../../helpers/date';
import { getFlightSegmentDate } from '../../../helpers/flights';
import { getFlightHours, getFlightMinutes, getFlightDuration/*, getStop*/ } from '../../../helpers/flights';
import '../../../output.css';


const FlightOfferSegment = ({segment, orig, dest}) => {
    
    
    const title = (start, name, code, date) => {
        return (
            <div>
                <span>{`${getFlightSegmentDate(date)},  ${getFlightHours(date)}:${getFlightMinutes(date)}`}</span>
                <span className='font-light ml-4 text-sm'>{`${start} ${name} (${code})`}</span>
            </div>
        )
    }; 

    const stopLabel = (name, code) => `${name} (${code})`; 
 
    //  lineWidth={2}
// bulletSize={16} lineVariant="dashed"

    return (
        <Timeline className='ml-4 mb-4'>
            {
                orig !== null && dest !== null && <div className='bg-gray-300 w-fit pl-4 pr-4 rounded-lg'>{`${getFlightDuration(orig, dest)} layover at ${stopLabel(segment.origin.name, segment.origin.iata_code)}`}</div>
            }
            <Timeline.Item  title={title("Depart from", segment.origin.name, segment.origin.iata_code, segment.departing_at)}>
                <p>{`Flight duration: ${getFlightDuration(segment.departing_at, segment.arriving_at)}`}</p>
            </Timeline.Item>

            <Timeline.Item title={title("Arrive at", segment.destination.name, segment.destination.iata_code, segment.arriving_at)}>
                <div className='block'>
                    <span className='mr-4'>{segment.passengers[0].cabin_class_marketing_name}</span>
                    <span className='mr-4'>{segment.marketing_carrier && segment.marketing_carrier.name}</span>
                       <span className='mr-4'>{segment.aircraft && segment.aircraft.name}</span>
                    <span className='mr-4'>{segment.aircraft && segment.aircraft.iata_code}</span>
                </div>
            </Timeline.Item>
        </Timeline>
    )
}


export default FlightOfferSegment;